//设置login 登录数据，暂时使用mock数据，
import defaultRouter from "./../router/default"
import ajaxUrl from "./ajaxurl"
import { methods as filterUtils } from '@/public/utils/filterUtils.js';
//获取左侧菜单以及用户信息
const RouterData = JSON.parse(localStorage.getItem('routerList'));
if (localStorage.getItem('token')) {
	var RouterList = defaultRouter(RouterData);
	//用于返回路由列表
	//RouterData && RouterData.userMenuAuthority ? RouterData.userMenuAuthority : defaultRouter;
} else {
	var RouterList = null;
}
//console.log(RouterData,localStorage.getItem('routerList'))
var userInfo = {};
if (RouterData) {
	userInfo = clone(RouterData)
}
userInfo.token = localStorage.getItem('token');
//loading
function startLoading() {
	let loaderBox = document.getElementById("loader_box");
	if (!loaderBox) {
		let div = document.createElement("div");
		div.setAttribute("class", "loader-box");
		div.setAttribute("id", "loader_box");
		let loadDiv = document.createElement("div");
		loadDiv.setAttribute("class", "loader-18");
		div.appendChild(loadDiv);
		document.body.appendChild(div);
	}
}
function endLoading() {
	let load = document.getElementById("loader_box");
	if (load) {
		load.remove();
	}

}

//推出登录
function loginout() {
	//localStorage.removeItem("token");
	//localStorage.removeItem("routerList");
	localStorage.clear();//清除所有缓存	，后续按需优化
	window.location.href = "/";
}
//去空格
function trim(str, type) {
	if (typeof str !== "string" || !str) {
		return str;
	}
	switch (type) {
		case "left":
			str = str.replace(/^\s*/, '');
			break;
		case "right":
			str = str.replace(/(\s*$)/g, "");
			break;
		case "both":
			str = str.replace(/^\s+|\s+$/g, "");
			break;
		default:
			str = str.replace(/\s+/g, "");
	}
	return str;
}
//数组是否全等
function arrayEqual(arr1, arr2) {
	if (arr1 === arr2) { return true; }
	if (arr1.length != arr2.length) { return false; }
	for (var i = 0; i < arr1.length; ++i) {
		if (arr1[i] !== arr2[i]) { return false; }
	}
	return true;
}
//深拷贝
function clone(obj) {
	var result = Array.isArray(obj) ? [] : {};
	for (var key in obj) {
		if (obj.hasOwnProperty(key)) {
			if (typeof obj[key] === 'object' && obj[key] !== null) {
				result[key] = clone(obj[key]);   //递归复制
			} else {
				result[key] = obj[key];
			}
		}
	}
	return result;
}
//加key
function setKey(arr, bc) {
	if (arr instanceof Array && arr.length) {
		for (let i = 0; i < arr.length; i++) {
			arr[i].key = i;
			if (typeof bc === "function") {
				bc(arr[i], i, arr);
			}
		}
	}
	return arr;
}
//数组去重
function moveRepeat(arr) {
	let tem = {}, newArr = [];
	if (arr instanceof Array) {
		for (let i = 0; i < arr.length; i++) {
			if (!tem[arr[i]]) {
				tem[arr[i]] = true;
			}
		}
		for (let k in tem) {
			newArr.push(k);
		}
	}
	return newArr;
}
//处理文件名称
function setFileName(t) {
	let arr = t.split("/");
	let name = arr[arr.length - 1];
	if (name) {
		let arr2 = name.split("-");
		if (arr2.length > 1) {
			name = "";
			arr2.shift();
			name = arr2.join("-");
		} else {
			name = arr2[0];
		}
	}
	return name;
}
//处理浮点数保留两位小数
function toPrice(v) {
	let num = 0;
	if (v) {
		num = Number(v).toFixed(2);
	}
	return num;
}
//默认表格设置
const tablePageConfig = {
	bordered: true, pageSize: 10, total: 0, showQuickJumper: true, showSizeChanger: true, current: 1,
	pageSizeOptions: ['10', '20', '50', '100', '200'],
	showTotal: (total, range) => `${range[0]}-${range[1]} 条 共 ${total}条`,
	buildOptionText: (p) => `${p.value}条/页`, size: "small"
}//每个表格显示15条数据

const systemMes = {
	type: 1,
	name: '赢家供应商协同平台',
}
export default {
	ajaxUrl,
	loginout,
	RouterList,
	userInfo,
	trim,
	tablePageConfig,
	clone,
	setKey,
	setFileName,
	arrayEqual,
	moveRepeat,
	toPrice,
	startLoading,
	endLoading,
	systemMes,
	decimal: filterUtils.decimal,
}


// WEBPACK FOOTER //
// ./src/public/index.js